/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import LocaleServiceBase from "bundle/service/LocaleService";

export default class LocaleService extends LocaleServiceBase {
    initialize(locale) {
        super.initialize(locale);
        LocaleService.getAllAllowedLocales().forEach(loc => Object.assign(this.loadedLocaleData[loc], require(`bundle/translations/${loc}.json`))); // eslint-disable-line
    }
}
